
if (!customElements.get('slick-fancy-box')) {
  class SlickFancyBox extends HTMLElement {
    abortController = undefined;
    allSlides = null;
    allThumbnails = null;
    filterTimeout = null;
    desktopBreakpoint = 767;
    resizeTimeout = null;
    imageTagLabel = '';
    variantTagLabels = null;
    sellingPlanObserver = null;
    sellingPlanInput = null;
    hideThumbnails = false;
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }
      if (this.filterTimeout) {
        clearTimeout(this.filterTimeout);
      }
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      if (this.sellingPlanObserver) {
        this.sellingPlanObserver.disconnect();
        this.sellingPlanObserver = null;
      }
      this.cleanup();
    }

    requestFilterUpdate(delay = 80) {
      if (this.filterTimeout) {
        clearTimeout(this.filterTimeout);
      }

      this.filterTimeout = setTimeout(() => {
        this.filterSlidesByVariant();
      }, delay);
    }


    init() {
      // Initialize slides and thumbnails
      this.isWelcomeKitEnabled = this.getAttribute('data-welcome-kit-enabled') === 'true';
      this.isSubscriptionFilterEnabled = this.getAttribute('data-subscription-filter-enabled') === 'true';
      this.hideThumbnails = this.getAttribute('data-hide-thumbnails') === 'true';
      this.allSlides = this.querySelectorAll('.hidden-main-slides .variant-slide');
      this.allThumbnails = this.hideThumbnails ? [] : this.querySelectorAll('.hidden-thumbnail-slides .variant-slide');
      this.imageTagLabel = (this.dataset && this.dataset.imageTagLabel ? this.dataset.imageTagLabel : '').trim();
      this.variantTagLabels = null;
      if (this.dataset && this.dataset.variantTagLabels) {
        try {
          this.variantTagLabels = JSON.parse(this.dataset.variantTagLabels);
        } catch (e) {
          this.variantTagLabels = null;
        }
      }

      // Set up event listeners
      this.setupEventListeners();
      
      // Initial filtering after DOM is ready
      this.requestFilterUpdate(10);

    }
    

    isDesktop() {
      return window.innerWidth >= this.desktopBreakpoint;
    }

    boostMainImages(mainSlider, count = 3) {
      if (!mainSlider) return;

      const imgs = Array.from(mainSlider.querySelectorAll('img'));
      if (!imgs.length) return;

      imgs.slice(0, count).forEach((img, idx) => {
        try {
          img.setAttribute('loading', 'eager');
          if (!img.getAttribute('decoding')) {
            img.setAttribute('decoding', 'async');
          }

          if (idx === 0) {
            img.setAttribute('fetchpriority', 'high');
            img.fetchPriority = 'high';
          } else {
            img.setAttribute('fetchpriority', 'auto');
            img.fetchPriority = 'auto';
          }
        } catch (e) {
          console.log(e);
        }
      });
    }

    applyAndEmitFirstSlideTag() {
      const label = (this.imageTagLabel || '').trim();

      const mainSlider = this.querySelector('.main-slider');
      if (!mainSlider) return;

      const firstSlideItem = mainSlider.querySelector('.variant-slide .slide-item');
      if (!firstSlideItem) return;

      // dispatch event for sticky image update
      this.dispatchEvent(new CustomEvent('product-media::updated', {bubbles: true, detail: { mainSlider, firstSlide: firstSlideItem}}));

      mainSlider.querySelectorAll('.product-media-gallery__tag-pill').forEach((el) => el.remove());

      if (!label) return;

      const pill = document.createElement('div');
      pill.className = 'product-media-gallery__tag-pill';
      pill.setAttribute('aria-hidden', 'true');
      pill.textContent = label;
      firstSlideItem.prepend(pill);
    }

    setupEventListeners() {
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();
    
      // Listen for renderSection completion to ensure DOM is fully updated
      document.addEventListener('renderSection:complete', (event) => {
        const eventSectionId = event?.detail?.sectionId;
        const mySectionId = this.closest('product-info')?.dataset?.section;
        if (eventSectionId && mySectionId && eventSectionId !== mySectionId) return;

        const variantId = event?.detail?.variant?.id;
        if (this.variantTagLabels && variantId) {
          this.imageTagLabel = (this.variantTagLabels[String(variantId)] || this.variantTagLabels[variantId] || '').trim();
        } else {
          this.imageTagLabel = '';
        }

        this.refreshSlideReferences();

        if (this.isSubscriptionFilterEnabled && this.isWelcomeKitEnabled) {
          this.setupSellingPlanListeners();
        }

        this.requestFilterUpdate(10);
      }, { signal: this.abortController.signal });

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.filterSlidesByVariant();
        }, 200);
      }, { signal: this.abortController.signal });

      if (this.isSubscriptionFilterEnabled && this.isWelcomeKitEnabled) {
          this.setupSellingPlanListeners();
      }

    }

    initGrid() {
      const mainSlider = this.querySelector('.main-slider');

      if (!mainSlider) return;

      // Fancybox only (zoom)
      $(this).find('.main-slider [data-fancybox]').fancybox({
        buttons: [
          "zoom",
          "fullScreen",
          "close"
        ],
        loop: false,
        protect: true,
        beforeShow: function(instance) {
          const uniqueItems = [];
          const seen = new Set();

          instance.group.forEach(item => {
            if (!seen.has(item.src)) {
              seen.add(item.src);
              uniqueItems.push(item);
            }
          });

          instance.group = uniqueItems;
        }
      });

    }

    setupSellingPlanListeners() {

      if (!this.isSubscriptionFilterEnabled) return;

      if (this.sellingPlanObserver) {
        this.sellingPlanObserver.disconnect();
        this.sellingPlanObserver = null;
      }

      const sellingPlanInput = document.querySelector('skio-plan-picker input.selected-selling-plan-id[name="selling_plan"]');
      
      if (!sellingPlanInput) {
        setTimeout(() => {
          this.setupSellingPlanListeners();
        }, 200);
        return;
      }

      this.sellingPlanInput = sellingPlanInput;

      const handleSellingPlanChange = () => {
        this.requestFilterUpdate(50);
      };


      this.sellingPlanObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            handleSellingPlanChange();
          }
        });
      });

      // Observe the input element for attribute changes
      this.sellingPlanObserver.observe(sellingPlanInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    
    refreshSlideReferences() {
      this.allSlides = this.querySelectorAll('.hidden-main-slides .variant-slide');
      this.allThumbnails = this.hideThumbnails ? [] : this.querySelectorAll('.hidden-thumbnail-slides .variant-slide');
    }
    
    // Check if subscription filtering should be applied
    shouldApplySubscriptionFilter() {
      return this.isWelcomeKitEnabled  &&  this.isSubscriptionFilterEnabled;
    }

    // Get the selling plan input value
    getSellingPlanInputValue() {
      const sellingPlanInput = document.querySelector('skio-plan-picker input.selected-selling-plan-id[name="selling_plan"]');
      if (!sellingPlanInput) {
        return '';
      }
      const value = sellingPlanInput.value || sellingPlanInput.getAttribute('value') || '';
      return value.trim();
    }

    isUserSubscribed() {
      if (!this.shouldApplySubscriptionFilter()) {
        return false;
      }

      const sellingPlanValue = this.getSellingPlanInputValue();
      return sellingPlanValue && sellingPlanValue !== '';

    }

    shouldShowImageBySubscription(mediaAlt) {
      const mediaAltLower = mediaAlt ? mediaAlt.toLowerCase() : '';
      const hasSubscriptionTag = mediaAltLower.includes('[subscribe]') || mediaAltLower.includes('[subscibe]');
      if (!this.shouldApplySubscriptionFilter()) {
        return !hasSubscriptionTag;
      }

      const isSubscribed = this.isUserSubscribed();

      return isSubscribed ? hasSubscriptionTag : !hasSubscriptionTag ;

    }

    filterSlidesByVariant() {
      const variantOptions = this.getAllSelectedVariantOptions();
      
      // Safety check: ensure DOM elements exist before proceeding
      const mainSlider = this.querySelector('.main-slider');
      const thumbnailNav = this.hideThumbnails ? null : this.querySelector('.thumbnail-nav');
      
      if (!mainSlider || !this.allSlides || (!this.hideThumbnails && (!thumbnailNav || !this.allThumbnails))) {
        console.warn('Media gallery elements not found, skipping filter');
        return;
      }
      
      try {
        const $main = $(this).find('.main-slider');
        const $thumbs = $(this).find('.thumbnail-nav');

        if ($main.hasClass('slick-initialized')) {
          $main.slick('unslick');
          if (!this.hideThumbnails && $thumbs.length) {
            $thumbs.slick('unslick');
          }
        }

        if (typeof $.fn.fancybox === 'function') {
          $(this).find('[data-fancybox]').fancybox('destroy');
        }
      } catch (error) {
        console.log(error);
      }
    
      mainSlider.innerHTML = '';
      if (!this.hideThumbnails && thumbnailNav) {
        thumbnailNav.innerHTML = '';
      }
    
      if (variantOptions.length === 0) {
        // Still apply subscription filtering even when no variant options are selected
        const filteredSlides = Array.from(this.allSlides).filter(slide => {
          const mediaAlt = slide.dataset.mediaAlt ? slide.dataset.mediaAlt.toLowerCase() : '';
          return this.shouldShowImageBySubscription(mediaAlt);
        });
        
        mainSlider.innerHTML = filteredSlides.map(slide => slide.outerHTML).join('');
        this.boostMainImages(mainSlider);
        if (!this.hideThumbnails && thumbnailNav) {
          const filteredThumbnails = Array.from(this.allThumbnails).filter(thumbnail => {
            const mediaAlt = thumbnail.dataset.mediaAlt ? thumbnail.dataset.mediaAlt.toLowerCase() : '';
            return this.shouldShowImageBySubscription(mediaAlt);
          });
          thumbnailNav.innerHTML = filteredThumbnails.map(thumbnail => thumbnail.outerHTML).join('');
        }
        this.applyAndEmitFirstSlideTag();
        this.isDesktop() ? this.initGrid() : this.initSlick();
        return;
      }
    
      // Get available options count for each visible variant type
      const availableOptionsCount = this.getAvailableOptionsCount();

      // Evaluate subscription state once (avoid repeated DOM queries)
      const subscriptionEnabled = this.shouldApplySubscriptionFilter();
      const isSubscribed = this.isUserSubscribed();

      const matchesSubscription = (mediaAltLower) => {
        const hasSubscribeTag = mediaAltLower.includes('[subscribe]') || mediaAltLower.includes('[subscribe]');
        if (!subscriptionEnabled) return !hasSubscribeTag;
        return isSubscribed ? hasSubscribeTag : !hasSubscribeTag;
      };

      const matchesSelectedOptions = (mediaAltLower, options) => {
        return options.every((selectedOption) => {
          const optionName = selectedOption.name;
          const optionValue = (selectedOption.value || '').toLowerCase();
          const requiredPattern = `[${optionValue}]`;

          // If this option type has only 1 available choice, don't require a tag in alt text.
          // This prevents falling into the "show all subscribe images" fallback when tags are missing.
          if (availableOptionsCount[optionName] === 1) return true;

          return mediaAltLower.includes(requiredPattern);
        });
      };
      
      const filteredSlides = Array.from(this.allSlides).filter(slide => {
        const mediaAltLower = slide.dataset.mediaAlt ? slide.dataset.mediaAlt.toLowerCase() : '';
        return matchesSubscription(mediaAltLower) && matchesSelectedOptions(mediaAltLower, variantOptions);
      });
    
      const filteredThumbnails = this.hideThumbnails
        ? []
        : Array.from(this.allThumbnails).filter(thumbnail => {
            const mediaAltLower = thumbnail.dataset.mediaAlt ? thumbnail.dataset.mediaAlt.toLowerCase() : '';
            return matchesSubscription(mediaAltLower) && matchesSelectedOptions(mediaAltLower, variantOptions);
          });
    
      if (filteredSlides.length === 0) {
        // Fallback (tight): keep subscription rule, but relax to the "primary" option only.
        // This prevents showing subscribe images from other variants when an option tag (often Size) is missing/duplicated.
        const primaryOptions = variantOptions.filter((opt) => /flavor|colour|color/i.test(opt.name));
        const fallbackVariantOptions = primaryOptions.length ? primaryOptions : variantOptions.slice(0, 1);

        let fallbackSlides = Array.from(this.allSlides).filter((slide) => {
          const mediaAltLower = slide.dataset.mediaAlt ? slide.dataset.mediaAlt.toLowerCase() : '';
          return matchesSubscription(mediaAltLower) && matchesSelectedOptions(mediaAltLower, fallbackVariantOptions);
        });

        let fallbackThumbnails = this.hideThumbnails
          ? []
          : Array.from(this.allThumbnails).filter((thumbnail) => {
              const mediaAltLower = thumbnail.dataset.mediaAlt ? thumbnail.dataset.mediaAlt.toLowerCase() : '';
              return matchesSubscription(mediaAltLower) && matchesSelectedOptions(mediaAltLower, fallbackVariantOptions);
            });

        // Last resort: if even primary option tags are missing, show based on subscription state only.
        if (fallbackSlides.length === 0) {
          fallbackSlides = Array.from(this.allSlides).filter((slide) => {
            const mediaAltLower = slide.dataset.mediaAlt ? slide.dataset.mediaAlt.toLowerCase() : '';
            return matchesSubscription(mediaAltLower);
          });
          fallbackThumbnails = this.hideThumbnails
            ? []
            : Array.from(this.allThumbnails).filter((thumbnail) => {
                const mediaAltLower = thumbnail.dataset.mediaAlt ? thumbnail.dataset.mediaAlt.toLowerCase() : '';
                return matchesSubscription(mediaAltLower);
              });
        }
        
        this.querySelector('.main-slider').innerHTML = fallbackSlides.map(slide => slide.outerHTML).join('');
        this.boostMainImages(mainSlider);
        if (!this.hideThumbnails && thumbnailNav) {
          thumbnailNav.innerHTML = fallbackThumbnails.map(thumbnail => thumbnail.outerHTML).join('');
        }
        this.applyAndEmitFirstSlideTag();
        this.isDesktop() ? this.initGrid() : this.initSlick();
        return;
      }
    
      // Remove duplicates - prefer stable media id over href
      const uniqueSlides = [];
      const seenMediaKeys = new Set();
      
      filteredSlides.forEach(slide => {
        const mediaIdEl = slide.querySelector('[data-media-id]');
        const mediaId = mediaIdEl ? mediaIdEl.getAttribute('data-media-id') : null;
        const fancyboxLink = slide.querySelector('[data-fancybox]');
        const href = fancyboxLink ? fancyboxLink.getAttribute('href') : null;
        const dedupeKey = mediaId || href || `index-${uniqueSlides.length}`;

        if (!seenMediaKeys.has(dedupeKey)) {
          seenMediaKeys.add(dedupeKey);
          uniqueSlides.push(slide);
        }
      });

      
      if(uniqueSlides.length <= 4){
        let newUniqueSlides = uniqueSlides;
        newUniqueSlides.forEach(thumbnail => {
          uniqueSlides.push(thumbnail);
        });
      }
    
      const uniqueThumbnails = [];
      if (!this.hideThumbnails) {
        const seenThumbKeys = new Set();
        
        filteredThumbnails.forEach(thumbnail => {
          const mediaIdEl = thumbnail.querySelector('[data-media-id]');
          const mediaId = mediaIdEl ? mediaIdEl.getAttribute('data-media-id') : null;
          const thumbImg = thumbnail.querySelector('img');
          const thumbSrc = thumbImg ? thumbImg.getAttribute('src') : null;
          const dedupeKey = mediaId || thumbSrc || `index-${uniqueThumbnails.length}`;
          
          if (!seenThumbKeys.has(dedupeKey)) {
            seenThumbKeys.add(dedupeKey);
            uniqueThumbnails.push(thumbnail);
          }
        });

        if (uniqueThumbnails.length <= 4) {
          let newuniqueThumbnails = uniqueThumbnails;
          newuniqueThumbnails.forEach(thumbnail => {
            uniqueThumbnails.push(thumbnail);
          });
        }
      }

    
      const galleryName = `gallery-${variantOptions.map(option => 
        option.value.toLowerCase().replace(/\s+/g, '-')
      ).join('-')}`;
      
      const slidesHTML = uniqueSlides.map(slide => {
        let slideHTML = slide.outerHTML;
        slideHTML = slideHTML.replace('data-fancybox="gallery"', `data-fancybox="${galleryName}"`);
        return slideHTML;
      }).join('');
    
      mainSlider.innerHTML = slidesHTML;
      this.boostMainImages(mainSlider);
      if (!this.hideThumbnails && thumbnailNav) {
        thumbnailNav.innerHTML = uniqueThumbnails.map(thumbnail => thumbnail.outerHTML).join('');
      }
      this.applyAndEmitFirstSlideTag();
      this.isDesktop() ? this.initGrid() : this.initSlick();
    }
    
    // Count available options for each VISIBLE variant type based on visible labels
    getAvailableOptionsCount() {
      const optionsCount = {};
      
      // Find all VISIBLE variant fieldsets
      const variantFieldsets = document.querySelectorAll('.product-form__input');
      
      variantFieldsets.forEach(fieldset => {
        // Check if fieldset is visible
        const isVisible = fieldset.offsetParent !== null && 
                        getComputedStyle(fieldset).display !== 'none' &&
                        getComputedStyle(fieldset).visibility !== 'hidden';
        
        if (isVisible) {
          const optionName = fieldset.querySelector('legend').textContent.replace(':', '').trim();
          
          // Find all visible labels (not hidden) within this fieldset
          const visibleLabels = fieldset.querySelectorAll('label:not([style*="display: none"]):not([style*="display:none"])');
          
          const uniqueValues = new Set();
          visibleLabels.forEach(label => {
            // Check if the label itself is visible
            const labelIsVisible = label.offsetParent !== null && 
                                  getComputedStyle(label).display !== 'none' &&
                                  getComputedStyle(label).visibility !== 'hidden';
            
            if (labelIsVisible) {
              // Get the value from the associated input or the label text
              const inputId = label.getAttribute('for');
              let optionValue = '';
              
              if (inputId) {
                const input = document.getElementById(inputId);
                if (input && !input.disabled) {
                  optionValue = input.value || label.textContent.trim();
                }
              } else {
                // Fallback to label text if no input association
                optionValue = label.textContent.trim();
              }
              
              if (optionValue && optionValue !== '') {
                uniqueValues.add(optionValue);
              }
            }
          });
          
          optionsCount[optionName] = uniqueValues.size;
        }
      });
      
      return optionsCount;
    }

    // Get selected options from VISIBLE fieldsets based on visible labels
    getAllSelectedVariantOptions() {
      const selectedOptions = [];
      
      const variantFieldsets = document.querySelectorAll('.product-form__input');
      
      variantFieldsets.forEach(fieldset => {
        // Check if fieldset is visible
        const isVisible = fieldset.offsetParent !== null && 
                        getComputedStyle(fieldset).display !== 'none' &&
                        getComputedStyle(fieldset).visibility !== 'hidden';
        
        if (isVisible) {
          const optionName = fieldset.querySelector('legend').textContent.replace(':', '').trim();
          
          // Find all checked inputs that have visible labels
          const checkedInputs = fieldset.querySelectorAll('input:checked:not([disabled])');
          
          checkedInputs.forEach(input => {
            // Find the label for this input
            const label = fieldset.querySelector(`label[for="${input.id}"]`);
            
            // Check if the label is visible
            if (label && label.offsetParent !== null && 
                getComputedStyle(label).display !== 'none' &&
                getComputedStyle(label).visibility !== 'hidden') {
              
              selectedOptions.push({
                name: optionName,
                value: input.value
              });
            }
          });
        }
      });
      
      return selectedOptions;
    }

    initSlick() {
      this.style.visibility = 'hidden';
      const $main = $(this).find('.main-slider');
      const $thumbs = $(this).find('.thumbnail-nav');

      // Initialize main slider
      const mainSliderConfig = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev"><svg class="prev-arrow" xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none"><path d="M5.11338 8.62707L1.37363 4.65637M1.37363 4.65637L5.11338 0.685652M1.37363 4.65637L12.0168 4.65637" stroke="#20544B" stroke-width="2"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg class="next-arrow" xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none"><path d="M6.90346 0.685669L10.6432 4.65637M10.6432 4.65637L6.90346 8.62709M10.6432 4.65637H0" stroke="#20544B" stroke-width="2"/></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.16,  // fractional slide only on mobile
              dots: true,
              arrows: false,
              prevArrow: '<button type="button" class="slick-prev"><svg class="prev-arrow" xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none"><path d="M5.11338 8.62707L1.37363 4.65637M1.37363 4.65637L5.11338 0.685652M1.37363 4.65637L12.0168 4.65637" stroke="#20544B" stroke-width="2"/></svg></button>',
              nextArrow: '<button type="button" class="slick-next"><svg class="next-arrow" xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none"><path d="M6.90346 0.685669L10.6432 4.65637M10.6432 4.65637L6.90346 8.62709M10.6432 4.65637H0" stroke="#20544B" stroke-width="2"/></svg></button>',
            }
          }
        ],
      };

      if (!this.hideThumbnails) {
        mainSliderConfig.asNavFor = '.thumbnail-nav';
      }

      $main.slick(mainSliderConfig);
      
      // Initialize thumbnail slider
      if (!this.hideThumbnails && $thumbs.length) {
        $thumbs.slick({
          slidesToShow: 4,
          infinite: true,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          focusOnSelect: true,
          asNavFor: '.main-slider',
        });
      }

      // Fancybox Config - target any gallery group
      $main.find('[data-fancybox]').fancybox({
        buttons: [
          "slideShow",
          "thumbs",
          "zoom",
          "fullScreen",
          "share",
          "close"
        ],
        loop: false,
        protect: true,
        beforeShow: function(instance, current) {
          // Remove duplicate items from the gallery before showing
          const uniqueItems = [];
          const seenSrcs = new Set();
          
          instance.group.forEach(item => {
            if (!seenSrcs.has(item.src)) {
              seenSrcs.add(item.src);
              uniqueItems.push(item);
            }
          });
          
          // Replace the gallery group with unique items only
          instance.group = uniqueItems;
        },
        // Handle different media types
        onInit: function(instance) {
          instance.group.forEach(item => {
            const $trigger = $(item.opts.$trigger);
            const mediaType = $trigger.data('type');
            
            if (mediaType === 'video') {
              item.type = 'video';
            } else if (mediaType === 'external_video') {
              item.type = 'iframe';
              // For external videos, we need to construct the proper embed URL
              if (item.src.includes('youtube.com') || item.src.includes('youtu.be')) {
                const videoId = item.src.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
                if (videoId) {
                  item.src = `https://www.youtube.com/embed/${videoId[1]}`;
                }
              } else if (item.src.includes('vimeo.com')) {
                const videoId = item.src.match(/vimeo\.com\/(\d+)/);
                if (videoId) {
                  item.src = `https://player.vimeo.com/video/${videoId[1]}`;
                }
              }
            } else if (mediaType === 'model') {
              item.type = 'iframe';
            }
          });
        }
      });

      // Also initialize Fancybox for cloned slides
      $main.find('[data-fancybox*="-clone"]').fancybox({
        buttons: [
          "slideShow",
          "thumbs",
          "zoom",
          "fullScreen",
          "share",
          "close"
        ],
        loop: false,
        protect: true,
        beforeShow: function(instance, current) {
          // Store current slide position before opening fancybox
          const currentSlide = $main.slick('slickCurrentSlide');
          $(document).data('slick-position-before-fancybox', currentSlide);
          
          // Get all unique media from both original and clone galleries
          const allMedia = [];
          const seenSrcs = new Set();
          
          // Get original gallery items
          $main.find('[data-fancybox]:not([data-fancybox*="-clone"])').toArray().forEach(link => {
            const src = link.getAttribute('href');
            const mediaType = link.getAttribute('data-type') || 'image';
            
            if (src && !seenSrcs.has(src)) {
              seenSrcs.add(src);
              allMedia.push({
                src: src,
                type: mediaType,
                caption: link.getAttribute('data-caption') || ''
              });
            }
          });
          
          // Replace the gallery group with all unique items
          instance.group = allMedia;
        },
        afterClose: function(instance, current) {
          // Restore the original slide position after closing fancybox
          const savedPosition = $(document).data('slick-position-before-fancybox');
          if (savedPosition !== undefined) {
            $main.slick('slickGoTo', savedPosition, false);
            $(document).removeData('slick-position-before-fancybox');
          }
        }
      });
      this.style.visibility = 'visible';
    }

    cleanup() {
      try {
        const $main = $(this).find('.main-slider');
        const $thumbs = $(this).find('.thumbnail-nav');

        if ($main.hasClass('slick-initialized')) {
          $main.slick('unslick');
        }
        if (!this.hideThumbnails && $thumbs.length && $thumbs.hasClass('slick-initialized')) {
          $thumbs.slick('unslick');
        }
        if (typeof $.fn.fancybox === 'function') {
          $(this).find('[data-fancybox]').fancybox('destroy');
        }
      } catch (error) {
        console.log('Cleanup error:', error);
      }
    }
  }

  customElements.define('slick-fancy-box', SlickFancyBox);
}